import React from "react";
import { Prompt, RouteComponentProps } from "react-router-dom";

import { Modal, Button } from "react-bootstrap";
import { withRouter } from "react-router-dom";

type Props = {
  //   navigate: (pathname: string) => any;
  when: boolean;
  shouldBlockNavigation: (route: string) => any;
  onExit: (...args: any[]) => any;
};

export const RouteLeavingGuard: React.SFC<Props & RouteComponentProps> = ({
  location,
  when,
  shouldBlockNavigation,
  onExit,
  history,
}) => {
  const [modalVisible, setModalVisible] = React.useState(false);
  const [nextLocation, setNextLocation] = React.useState<
    null | RouteComponentProps["location"]
  >(null);
  const [confirmedNavigation, setConfirmedNavigation] = React.useState(false);

  React.useEffect(() => {
    window.onbeforeunload = () => true;
    return () => {
      window.onbeforeunload = null;
      return;
    };
  }, []);

  const handleBlockedNavigation = (nextLocation) => {
    if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
      setTimeout(() => {
        setModalVisible(true);
        setNextLocation(nextLocation);
      });
      return false;
    }

    return true;
  };

  React.useEffect(() => {
    if (confirmedNavigation) {
      // Navigate to the previous blocked location with your navigate function
      if (nextLocation) {
        if (location.pathname === nextLocation.pathname) {
          history.push("/empty");
          setTimeout(() => {
            history.push(nextLocation.pathname);
          });
        } else {
          history.push({
            pathname: nextLocation.pathname,
            search: nextLocation.search,
          });
        }
        onExit();
      }
    }
  }, [confirmedNavigation]);

  return (
    <>
      <Prompt
        when={when}
        message={(nextLocation) => handleBlockedNavigation(nextLocation)}
      />

      <Modal show={modalVisible}>
        <Modal.Header>Do you want to leave this page?</Modal.Header>

        <Modal.Body>
          <p>Changes you've made may not be saved.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            // style={{ width: "80px" }}
            variant="secondary"
            onClick={() => setModalVisible(false)}
          >
            Go Back
          </Button>
          <Button
            // style={{ width: "80px" }}
            variant="danger"
            onClick={() => {
              setConfirmedNavigation(true);
              setModalVisible(false);
            }}
          >
            Exit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withRouter(RouteLeavingGuard);
